var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"width":"372px","height":"240px"},attrs:{"id":"myChart"}})}
var staticRenderFns = []

export { render, staticRenderFns }